module.exports = require("process");


//////////////////
// WEBPACK FOOTER
// external "process"
// module id = 232
// module chunks = 0